import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RowTransactionListComponent } from './row-transaction-list.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { CoreModule } from '@app/core/core.module';
import { MatIconModule } from '@angular/material/icon';
import { StatesSeparatorModule } from '@app/transactions/components/state-chat/states-separator/states-separator.module';
import { BtnTransactionDetailsModule } from '@app/dashboard/components/btn-transaction-details/btn-transaction-details.module';
import { RouterModule } from '@angular/router';
import { StepperTransactionStatesModule } from '@app/transactions/pages/transaction-info/transaction-operation-data/transaction-info-state/stepper-transaction-states/stepper-transaction-states.module';
import { TransactionInfoService } from '@app/transactions/pages/transaction-info/transaction-info.service';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { PipesModule } from '@app/core/pipes/pipes.module';

@NgModule({
    declarations: [RowTransactionListComponent],
    exports: [RowTransactionListComponent],
    imports: [
        CommonModule,
        MatExpansionModule,
        MatDividerModule,
        CoreModule,
        MatIconModule,
        StatesSeparatorModule,
        BtnTransactionDetailsModule,
        StepperTransactionStatesModule,
        MatButtonModule,
        PipesModule,
        RouterModule
    ],
    providers: [TransactionInfoService]
})
export class RowTransactionListModule {}
